import { ChevronRight, Megaphone } from "lucide-react";
import { Link } from "react-router";
import ChangelogCounter from "@/features/changelogs/components/ChangelogCounter";
import { CHANGELOGS_PAGE_PATH } from "@/shared/configs/routes.config";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/ui/Tooltip";

type ChangelogLinkProps = { collapsed: boolean };

const ChangelogLink = ({ collapsed }: ChangelogLinkProps) => {
  if (collapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to={CHANGELOGS_PAGE_PATH}
            className="relative flex items-center justify-center"
          >
            <Megaphone className="size-3.5 text-gray-400 hover:text-primary transition-colors" />
            <span className="absolute -top-0.5 -right-1">
              <ChangelogCounter />
            </span>
          </Link>
        </TooltipTrigger>
        <TooltipContent side="right">Mises à jour</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Link
      to={CHANGELOGS_PAGE_PATH}
      className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-primary transition-colors"
    >
      <ChangelogCounter />
      <span>Mises à jour</span>
      <ChevronRight className="size-3" />
    </Link>
  );
};

export default ChangelogLink;
